import clsx from 'clsx';
import Img from '@/components/Img';
import styles from './ImageTextLabel.module.scss';
import Text from '@/components/Text/Text';
import { mediaPath } from '@/mediaPath';

export interface ImageTextLabelProps {
  data: {
    title?: string;
    label?: string;
    description?: string;
    image?: {
      height: number,
      width: number,
      url: string,
      mime?: string;
    };
    imagePosition?: 'left' | 'right';
    imageSize?: 'small' | 'medium' | 'large';
  },
}

const ImageTextLabel = ({ data }: ImageTextLabelProps) => {
  const isVideo = data.image?.mime?.startsWith('video');
  const mediaUrl = data.image?.url ? mediaPath(data.image.url) : null;

  return (
    <section className={clsx(styles.ImageTextLabel, { [styles.left]: data.imagePosition === 'left' }, 'custom')}>
      <div className={clsx(styles.content, { [styles.left]: data.imagePosition === 'left' }, 'custom')}>
        <div className={styles.textContent}>
          <div className={styles.titleContainer}>
            {data.label && (
              <Text
                className={styles.label}
                tag='p'
              >
                {data.label}
              </Text>
            )}
            {data.title && (
              <Text
                className={styles.title}
                tag='h3'
              >
                {data.title}
              </Text>
            )}
          </div>
          {data.description && (
            <div
              className={styles.description}
              dangerouslySetInnerHTML={{
                __html: data.description,
              }}
            />
          )}
        </div>
        {mediaUrl && (
          isVideo ? (
            <video
              key={mediaUrl}
              className={clsx(styles.media, styles[data.imageSize || 'medium'])}
              src={mediaUrl}
              autoPlay
              loop
              muted
              playsInline
              preload='auto'
            >
              <track kind='captions' />
              Your browser does not support the video tag.
            </video>
          ) : (
            data.image && (
              <Img
                key={mediaUrl}
                src={data.image.url}
                className={clsx(styles.media, styles[data.imageSize || 'medium'])}
                height={data.image?.height}
                width={data.image?.width}
                alt={data.title || ''}
              />
            ))
        )}
      </div>
    </section>
  );
};

export default ImageTextLabel;
